import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.FRAUD_MANAGEMENT.GLOBAL_SETTINGS_MENU;

const GlobalSettingsMenu: Array<LinkItemProps> = [
  {
    name: 'Emetteur',
    level: 2,
    subMenu: [
      {
        name: 'Règles',
        link: URL.GLOBAL_SETTINGS_EMITTER_MENU.RULES,
        level: 3,
      },
      {
        name: 'Autre Règles',
        level: 3,
        subMenu: [
          {
            name: 'Essais Autorisation Rejetée',
            link: URL.GLOBAL_SETTINGS_EMITTER_MENU.OTHER_RULES_MENU.TRIALS_AUTHORIZATION_REJECTED,
            level: 4,
          },
          {
            name: 'Disponible à Dépenser',
            link: URL.GLOBAL_SETTINGS_EMITTER_MENU.OTHER_RULES_MENU.AVAILABLE_TO_SPEND,
            level: 4,
          },
        ]
      },
      {
        name: 'Gestion Règles',
        link: URL.GLOBAL_SETTINGS_EMITTER_MENU.RULES_MANAGEMENT,
        level: 3,
      },
      {
        name: 'Déplacement Règles',
        link: URL.GLOBAL_SETTINGS_EMITTER_MENU.MOVING_RULES,
        level: 3,
      },
    ]
  },
  {
    name: 'Risque MCC',
    link: URL.MCC_RISK,
    level: 2,
  },
  {
    name: 'Risque Pays',
    link: URL.COUNTRY_RISK,
    level: 2,
  },
  {
    name: 'Groupe MCC Risque',
    link: URL.MCC_RISK_GROUP,
    level: 2,
  },
  
];

export default GlobalSettingsMenu;
